const Style = {
    section: 'relative overflow-hidden py-16 md:py-24 bg-primary-900',

    glow: `pointer-events-none absolute -bottom-52 -right-32 w-[620px] h-[520px]
    bg-[radial-gradient(50%_50%_at_50%_50%,rgba(129,140,248,0.28),transparent_70%)]`,

    eyebrow: 'text-[13px] font-semibold tracking-[0.08em] uppercase text-primary-300 mb-3.5',
    title: 'text-3xl md:text-[36px] font-bold tracking-[-0.02em] text-white mt-0 mb-4',
    lede: 'text-base md:text-[17px] leading-relaxed text-primary-200 max-w-[460px] mb-7',
    actions: 'flex flex-wrap gap-3',

    // Was the orange accent. Orange was retired when the token layer moved onto
    // the reference (open question 1), and the reference's replacement accent is
    // a LIGHTER indigo — which reads badly here: low contrast against this
    // primary-900 band and against its own white label. The reference has no
    // dark band to copy, so this follows the treatment already used by the form
    // submit beside it: white on indigo, the highest contrast available.
    primary: `inline-block text-[15px] font-semibold text-primary-900 bg-white hover:bg-white/90
    px-5 py-3 rounded-lg no-underline transition-colors duration-150 ease-out`,
    email: `inline-block text-[15px] font-medium text-white px-5 py-3 rounded-lg no-underline
    border border-solid border-white/30 hover:bg-white/10 transition-colors duration-150 ease-out`,

    // `landing-cta-form` recolours the shared Form for this dark band —
    // see the @layer components block in src/css/input.css
    card: 'landing-cta-form rounded-2xl bg-white/5 border border-solid border-white/15 p-7',
};

export default Style;
